// src/components/layout/IdleAlerts.js
import React, { useEffect, useState } from 'react';
import { useApp } from '../../contexts/AppContext';

function IdleAlertCard({ alert, onDismiss, truckColor }) {
  const [progress, setProgress] = useState(100);
  const duration = alert.duration || 8;

  useEffect(() => {
    const start = Date.now();
    const iv = setInterval(() => {
      const elapsed = (Date.now() - start) / 1000;
      const pct = Math.max(0, 100 - (elapsed / duration) * 100);
      setProgress(pct);
      if (pct <= 0) clearInterval(iv);
    }, 100);
    return () => clearInterval(iv);
  }, [duration]);

  const time = new Date(alert.timestamp).toLocaleTimeString('en-PH', {
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });

  return (
    <div style={{
      background: 'var(--bgModal)',
      border: `1px solid ${truckColor || '#f59e0b'}66`,
      borderLeft: `4px solid ${truckColor || '#f59e0b'}`,
      borderRadius: 12,
      padding: '14px 16px',
      backdropFilter: 'blur(16px)',
      boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      animation: 'slideInRight 0.3s ease',
      position: 'relative',
      overflow: 'hidden',
      minWidth: 320,
      maxWidth: 380,
    }}>
      {/* Progress bar */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 3, background: 'var(--border)' }}>
        <div style={{ height: '100%', width: `${progress}%`, background: truckColor || '#f59e0b', transition: 'width 0.1s linear', borderRadius: '0 0 0 12px' }} />
      </div>

      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        {/* Icon */}
        <div style={{ width: 38, height: 38, borderRadius: 10, background: (truckColor || '#f59e0b') + '22', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 }}>
          ⏸
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 14, color: 'var(--textPrimary)' }}>
              Truck Idle
            </div>
            <div style={{ fontSize: 10, color: 'var(--textFaint)' }}>{time}</div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: truckColor || '#f59e0b', flexShrink: 0 }} />
            <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--textPrimary)', fontFamily: 'Syne, sans-serif' }}>
              {alert.plateNumber}
            </span>
            <span style={{ fontSize: 11, color: 'var(--textMuted)' }}>· {alert.driver}</span>
          </div>

          <div style={{ fontSize: 12, color: 'var(--textSecondary)', display: 'flex', alignItems: 'center', gap: 5 }}>
            <span>📍</span>
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{alert.address}</span>
          </div>
        </div>

        {/* Dismiss */}
        <button onClick={() => onDismiss(alert.id)} style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 6, color: 'var(--textFaint)', cursor: 'pointer', width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, flexShrink: 0 }}>✕</button>
      </div>
    </div>
  );
}

export default function IdleAlerts() {
  const { idleAlerts, dismissIdleAlert, trucks } = useApp();

  if (!idleAlerts || idleAlerts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 24,
      right: 24,
      zIndex: 9998,
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      alignItems: 'flex-end',
    }}>
      {idleAlerts.map(alert => {
        const truck = trucks.find(t => t.id === alert.truckId);
        return (
          <IdleAlertCard
            key={alert.id}
            alert={alert}
            onDismiss={dismissIdleAlert}
            truckColor={truck?.color}
          />
        );
      })}
    </div>
  );
}
